/**
 * Created by 唐亦慧 on 2017/8/31.
 */
import Reflux from 'reflux';

export const Actions = Reflux.createActions([
	'paramChange',
	'useStoreChange'
]);

export class Store extends Reflux.Store {
	constructor() {
		super();
		this.state = {
      useStore: false,
      params: {
        code: '',
        customerName: '',
        startCreatedDate: '',
        endCreatedDate: '',
        areaId: '',
        orderStatus: '',
        payStatus: '',
        s: 10,
        p: 1
      }
    };
		this.listenables = Actions;
	}
	
	useStoreChange(flag){
		this.setState({
			...this.state,
			useStore: flag
		});
	}
	paramChange(data){
		this.setState({
			...this.state,
			storeData:{
				...this.state.storeData,
				...data
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/routes/searchOwning/store.js